/* eslint-disable react/prop-types */
import * as components from '../components';

const normalizeKey = (str) =>
	str?.trim()?.replace('ContentfulContent', '').replace(/[\s-]/, '');

export const ComponentMapper = ({ section }) => {
	const Component =
		components[`${normalizeKey(section.type)}${normalizeKey(section.variant) || ''}`];

	if (Component) {
		return <Component {...section} />;
	}

	return null;
};

export const mapCard = (item) => ({
	...item,
	desktopIcon: {
		data: item?.desktopIcon?.gatsbyImageData,
		src: item?.desktopIcon?.file?.url,
		alt: item?.desktopIcon?.description,
	},
});

export const mapIcon = (item) => ({
	...item,
	description: item?.description?.childMarkdownRemark?.html,
	icon: {
		data: item?.icon?.gatsbyImageData,
		src: item?.icon?.file?.url,
		alt: item?.icon?.description,
	},
});

export const mapToCardItem = ({ node }) => ({
	...node,
	headerImage: {
		data: node.headerImage?.gatsbyImageData,
		src: node.headerImage?.file?.url,
		alt: node.headerImage?.description,
	},
	excerpt: node?.excerpt?.childMarkdownRemark?.html,
});

export const mapPageSlug = (node) => {
	const slug = node?.compose__page?.[0]?.slug;
	return {
		...node,
		slug: mapBlogNewsSlug('Blog', slug),
	};
};

export const mapBlogNewsSlug = (type, slug) => {
	switch (type) {
	case 'Blog':
		return `/blog/${slug}`;
	case 'News':
		return `/news/${slug}`;
	default:
		return undefined;
	}
};
